import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import BedPolicy from './BedPolicy';
import BreakfastPolicy from './BreakfastPolicy';
import ImportantNoticePolicy from './ImportantNoticePolicy';
import PaymentCardPolicy from './PaymentCardPolicy';

import type { HotelPolicy } from '@shared/types/hotel-content';

import STYLES from './HotelPolicyContent.module.scss';

import {
  BED_POLICY_MAP,
  IMPORTANT_NOTICE_POLICY,
  POLICY_UBFF_MAP,
} from '@shared/ui/components/HotelPolicyMapping';

const cls = cssModules(STYLES);

type Props = {
  policy: HotelPolicy;
};

const HotelPolicyContent = ({ policy }: Props) => {
  const isPaymentCardPolicy =
    policy.type === POLICY_UBFF_MAP.HOTEL_POLICY_TYPE_PAYMENT_METHOD &&
    policy.paymentMethodPolicyDetails;
  const isBreakfastPolicy =
    policy.type === POLICY_UBFF_MAP.HOTEL_POLICY_TYPE_BREAKFAST &&
    policy.breakfastPolicyDetails;

  const bedPolicy = policy.bedPolicyDetails;
  const isBedPolicy =
    policy.type &&
    BED_POLICY_MAP[policy.type] &&
    bedPolicy &&
    bedPolicy.items.length > 0;

  const importantNoticePolicy = policy.importantNoticePolicyDetails;
  const isImportantNoticePolicy = !!(
    policy.type &&
    IMPORTANT_NOTICE_POLICY[policy.type] &&
    importantNoticePolicy?.content
  );

  const isTextPolicies =
    !isPaymentCardPolicy &&
    !isBreakfastPolicy &&
    !isBedPolicy &&
    !isImportantNoticePolicy;

  return (
    <div className={cls('HotelPolicyContent')}>
      {isPaymentCardPolicy && (
        <PaymentCardPolicy
          policy={policy.paymentMethodPolicyDetails}
          key={POLICY_UBFF_MAP.HOTEL_POLICY_TYPE_PAYMENT_METHOD}
        />
      )}
      {isBreakfastPolicy && (
        <BreakfastPolicy
          policy={policy.breakfastPolicyDetails}
          key={POLICY_UBFF_MAP.HOTEL_POLICY_TYPE_BREAKFAST}
        />
      )}
      {isBedPolicy && <BedPolicy policy={bedPolicy} key={policy.type} />}
      {isImportantNoticePolicy && (
        <ImportantNoticePolicy policy={importantNoticePolicy} />
      )}
      {isTextPolicies && (
        <BpkText
          tagName="p"
          className={cls(
            'HotelPolicyContent__text',
            'HotelPolicyContent__noticeContent',
          )}
        >
          {policy.textPolicyDetails}
        </BpkText>
      )}
    </div>
  );
};

export default HotelPolicyContent;
